module.exports = __webpack_public_path__ + "img/AT0000001017373.30a7524f.png";